import { trpc } from '@/shared/api';

/** 한 상품이 허용한 폰트 목록 조회 — 상품 편집 화면의 허용 폰트 섹션이 쓴다. */
export const useProductFontsQuery = (productId: string) =>
  trpc.productManagement.fonts.listForProduct.useQuery({ productId });
